import React, { useEffect, useState } from "react";
import Header from "../../component/menu/Header";
import SideMenu from "../../component/menu/SideMenu";
import { ConfigProvider, message, Pagination, Spin } from "antd";
import ApiService from "../../utils/ApiService";
import useUserStore from "../../stores/store";
import CustomLoader from "../../component/menu/CustomLoader";
import DataNotFound from "../../component/common/DataNotFound";
import RestaurantSwitchItemComponent from "../../component/RestaurantSwitchItemComponent";
import CustomInput from "../../component/CustomInput";

function RestaurantSwitch() {
  const { user } = useUserStore();
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBuy] = useState("NEWEST");
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  const [restaurants, setRestaurants] = useState([]);
  const [totalRestaurants, setTotalRestaurants] = useState(0);
  const [params, setParams] = useState({
    searchKey: searchText,
    status: "",
    sortBy: sortBy,
    page: currentPage,
    perPage: perPage,
  });
  
  const [loadingRestaurant, setLoadingRestaurant] = useState(true);

  const handleSearch = () => {
    setParams((prev) => ({
      ...prev,
      searchKey: searchText,
      page: 1, // Reset to first page on new search
      perPage: perPage,
    }));
  };
  
  async function getRestaurantList(params) {
    params.perPage = perPage;
    params.sortBy = params.sortBy.toLowerCase();
    const token = user.token.token;
    try {
      setLoadingRestaurant(true);

      const { payload } = await ApiService.GET_RESTAURANTS(params, token);
      setRestaurants(payload.records);
      setCurrentPage(payload.page);
      setTotalRestaurants(payload.total);
    } catch (error) {
      message.error("Failed to fetch restaurant list");
    } finally {
      setLoadingRestaurant(false);
    }
  }

  const onShowSizeChange = (current, pageSize) => {
    setPerPage(pageSize);
    setCurrentPage(current);
  };

  const onPageChange = (value) => {
    setCurrentPage(value);
    setParams((prev) => ({
      ...prev,
      page: value,
    }));
  };
  useEffect(() => {
    getRestaurantList(params);
  }, [params]);

  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      <CustomLoader />
      <Header
        title={""}
        menu={''}
        currentMenuKey={""}
      />
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={''}
        />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <div className="text-lg font-semibold mb-5">Switch Restaurant</div>
            <div className="flex justify-end space-x-4">
              <div className="w-1/3">
                <CustomInput
                  value={searchText}
                  setValue={setSearchText}
                  showPadding={false}
                  required={false}
                  onPressEnter={handleSearch}
                  placeholder="Search Restaurant"
                  inputClasses="indent-5 outline-none h-[40px]"
                />
              </div>
              <div>
                <button
                  className="h-[42px] w-[100px] bg-[#FCBD10] text-black text-[14px] font-bold leading-[16px] rounded-lg"
                  onClick={handleSearch}
                >
                  Apply
                </button>
              </div>
            </div>
            <div className="flex flex-col">
              {loadingRestaurant ? (
                <div className="h-[70vh] flex items-center justify-center">
                  <Spin size="large" />
                </div>
              ) : restaurants?.length > 0 ? (
                restaurants.map((item, index) => {
                  return (
                    <div key={`res-${index}-${item.id}`}>
                      <RestaurantSwitchItemComponent
                        record={{
                          id: item.id,
                          _name: item.name,
                          logo: item.logo,
                          status: item.status,
                          createdAt: item.createdAt,
                        }}
                        parentRestaurants={user?.isRestaurantSwitchEnabled ? user.superAdminRestaurants : user.restaurants}
                      />
                    </div>
                  );
                })
              ) : (
                <DataNotFound />
              )}

              {}
            </div>
            <div className="flex flex-row justify-start font-uregular">
              <ConfigProvider
                theme={{
                  components: {
                    Pagination: {
                      itemActiveBg: "#FFD700",
                      fontFamily: "ubold",
                      colorPrimaryBorder: "#FFD700",
                      colorPrimary: "#111111",
                      colorPrimaryHover: "#111111",
                      itemInputBg: "#111111",
                      itemBg: "#E5E4E9",
                    },
                  },
                }}
              >
                <Pagination
                  total={totalRestaurants}
                  showSizeChanger={false}
                  onShowSizeChange={onShowSizeChange}
                  showTotal={(total) => `Total ${total} items`}
                  defaultPageSize={perPage}
                  defaultCurrent={currentPage}
                  current={currentPage}
                  onChange={onPageChange}
                />
              </ConfigProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RestaurantSwitch;
